import React, { Component } from 'react'
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import { GridList, GridTile } from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import Divider from 'material-ui/Divider';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import AddIcon from 'material-ui/svg-icons/content/add';
import SaveIcon from 'material-ui/svg-icons/content/save';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';

import PhotosDialog from './PhotosDialog';
import VideosDialog from './VideosDialog';
import * as DataAPI from "../../../common/DataAPI.js";
import Dialogs from "../../../common/Dialogs.js";
import constants from "../../../common/constants.js";

const mediaToolBarTitles = ['廣告'];
const advPositionsMapping = {
  0: '大',
  1: '細',
};

class Display extends Component {
  constructor() {
    super();
    this.state = {
      displays: [{
        name: '',
        isKiosk: false,
        advPositions: [],
        footerText: '',
      }],
      displaySelected: null,
      advPositionSelected: null,
      shouldOpenPhotosDialog: false,
      shouldOpenVideosDialog: false,
      schedulingIndex: '',
    };

    this.onDisplaySelected = this.onDisplaySelected.bind(this);
    this.onAdvPositionSelected = this.onAdvPositionSelected.bind(this);
    this.updateAdvPositionSelected = this.updateAdvPositionSelected.bind(this);
    this.updateScheduleToShow = this.updateScheduleToShow.bind(this);
    this.updateDisplaySelected = this.updateDisplaySelected.bind(this);
    this.submitPhotos = this.submitPhotos.bind(this);
    this.removePhoto = this.removePhoto.bind(this);
    this.openPhotoDialog = this.openPhotoDialog.bind(this);
    this.closePhotoDialog = this.closePhotoDialog.bind(this);
    this.openVideoDialog = this.openVideoDialog.bind(this);
    this.closeVideoDialog = this.closeVideoDialog.bind(this);
    this.removeVideo = this.removeVideo.bind(this);
    this.submitVideos = this.submitVideos.bind(this);
    this.save = this.save.bind(this);
  }

  componentWillMount() {
    this.refreshDisplays();
  }

  refreshDisplays() {
    DataAPI.get('/api/adminPanel/displays', {}, (err, displays) => {
      if (err) return this.dialogs.error(err);

      const displaySelected = this.state.displaySelected ? _.find(displays, { _id: this.state.displaySelected._id }) : _.head(displays);
      const advPositionSelected = this.state.advPositionSelected ? _.find(displaySelected.advPositions, { _id: this.state.advPositionSelected._id }) : _.head(displaySelected.advPositions);

      this.setState({
        displays,
        displaySelected,
        advPositionSelected,
      });
    });
  }

  updateDisplaySelected(field, value) {
    let displaySelected = { ...this.state.displaySelected };

    displaySelected[field] = value;

    this.setState({
      displaySelected,
    });
  }

  updateAdvPositionSelected(field, value) {
    let advPositionSelected = { ...this.state.advPositionSelected };

    advPositionSelected[field] = value;

    this.setState({
      advPositionSelected,
    }, () => {
      const advPositions = _.map(this.state.displaySelected.advPositions, advPosition => {
        return advPosition._id === advPositionSelected._id ? advPositionSelected : advPosition;
      });

      this.updateDisplaySelected('advPositions', advPositions);
    });
  }

  updateScheduleToShow(index, field, value) {
    let scheduleToShow = { ...this.state.advPositionSelected.scheduleToShow };

    scheduleToShow[index][field] = value;

    this.updateAdvPositionSelected('scheduleToShow', scheduleToShow);
  }

  submitPhotos(schedulingIndex, photos) {
    let scheduleToShow = { ...this.state.advPositionSelected.scheduleToShow };

    let photosToUpdate = _.concat(scheduleToShow[schedulingIndex].photos, photos);
    this.updateScheduleToShow(schedulingIndex, 'photos', photosToUpdate);

    this.closePhotoDialog();
  }

  openPhotoDialog(schedulingIndex) {
    this.setState({
      shouldOpenPhotosDialog: true,
      schedulingIndex,
    });
  }

  closePhotoDialog() {
    this.setState({
      shouldOpenPhotosDialog: false,
    });
  }

  removePhoto(photoIndex, schedulingIndex) {
    const photos = _.cloneDeep(this.state.advPositionSelected.scheduleToShow[schedulingIndex].photos);
    _.pullAt(photos, [photoIndex]);

    this.updateScheduleToShow(schedulingIndex, 'photos', photos);
  }

  openVideoDialog(schedulingIndex) {
    this.setState({
      shouldOpenVideosDialog: true,
      schedulingIndex,
    });
  }

  closeVideoDialog() {
    this.setState({
      shouldOpenVideosDialog: false,
    });
  }

  submitVideos(schedulingIndex, videos) {
    let scheduleToShow = { ...this.state.advPositionSelected.scheduleToShow };

    let videosToUpdate = _.concat(scheduleToShow[schedulingIndex].videos, videos);
    this.updateScheduleToShow(schedulingIndex, 'videos', videosToUpdate);

    this.closeVideoDialog();
  }

  removeVideo(videoIndex, schedulingIndex) {
    const videos = _.cloneDeep(this.state.advPositionSelected.scheduleToShow[schedulingIndex].videos);
    _.pullAt(videos, [videoIndex]);

    this.updateScheduleToShow(schedulingIndex, 'videos', videos);
  }

  save() {
    DataAPI.post('/api/adminPanel/display', this.state.displaySelected, (err, displayUpdated) => {
      if (err) return this.dialogs.error(err);

      this.dialogs.alert({
        title: '成功更新屏幕',
      });
      this.refreshDisplays();
    });
  }

  onDisplaySelected(event, index, value) {
    const displaySelected = _.find(this.state.displays, { _id: value });
    const advPositionSelected = _.head(displaySelected.advPositions);

    this.setState({
      displaySelected,
      advPositionSelected,
    });
  }

  onAdvPositionSelected(event, index, value) {
    const advPositionSelected = _.find(this.state.displaySelected.advPositions, { _id: value });

    this.setState({
      advPositionSelected,
    });
  }

  onNumberOfTicketSelected(event, index, value) {
    this.updateDisplaySelected('numberOfTicketToPrint', value);
  }

  render() {
    const wrapSelectFieldOnChange = (field, event, index, value) => {
      this.updateDisplaySelected(field, value);
    };

    const wrapOnChange = (field, event, value) => {
      this.updateDisplaySelected(field, value);
    };

    return (
      <div className="admin-display-block">
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle
              text="屏幕管理" />
          </ToolbarGroup>
          <ToolbarGroup
            lastChild={true}>
            <RaisedButton
              label="儲存"
              icon={<SaveIcon />}
              primary={true}
              onClick={this.save}
            />
          </ToolbarGroup>
        </Toolbar>
        <SelectField
          floatingLabelText="屏幕"
          value={_.get(this.state.displaySelected, '_id')}
          onChange={this.onDisplaySelected}
        >
          {
            _.map(this.state.displays, (display, index) =>
              <MenuItem value={display._id} primaryText={display.name} key={index} />
            )
          }
        </SelectField>
        {
          this.state.displaySelected &&
          <div>
            {
              this.state.displaySelected.isKiosk && constants.canConfigNoOfTicketDispensed &&
              <div>
                <SelectField
                  floatingLabelText="列印輪候票數量"
                  value={_.get(this.state.displaySelected, 'numberOfTicketToPrint')}
                  onChange={wrapSelectFieldOnChange.bind(this, 'numberOfTicketToPrint')}
                >
                  <MenuItem value={1} primaryText={1} />
                  <MenuItem value={2} primaryText={2} />
                </SelectField>
              </div>
            }
            {
              this.state.displaySelected.canEditMedia &&
              <div>
                <SelectField
                  floatingLabelText="廣告位置"
                  value={_.get(this.state.advPositionSelected, '_id')}
                  onChange={this.onAdvPositionSelected}
                >
                  {
                    _.map(this.state.displaySelected.advPositions, (advPosition, index) =>
                      <MenuItem value={advPosition._id}
                                primaryText={advPositionsMapping[advPosition.row]}
                                key={index} />
                    )
                  }
                </SelectField>
                {
                  this.state.advPositionSelected &&
                  _.map(this.state.advPositionSelected.scheduleToShow, (schedulingItem, schedulingIndex) =>
                    <div key={schedulingIndex} className="media-block">
                      <Toolbar className="tool-bar">
                        <ToolbarGroup className="tool-bar-group">
                          <ToolbarTitle
                            className="tool-bar-title"
                            text={mediaToolBarTitles[schedulingIndex]} />
                        </ToolbarGroup>
                      </Toolbar>
                      {
                        (schedulingItem.mediaType === 'photo' || schedulingItem.mediaType === 'none') &&
                        <div className="photo-block">
                          <FlatButton
                            label="插入相片"
                            primary={true}
                            icon={<AddIcon />}
                            onClick={this.openPhotoDialog.bind(this, schedulingIndex)}
                            disabled={_.size(schedulingItem.photos) >= 20} />
                          <div className="photos-grid-list">
                            <GridList
                              cellHeight={200}
                              cols={3}
                            >
                              {_.map(schedulingItem.photos, (photo, photoIndex) => (
                                <GridTile
                                  key={photoIndex}
                                  title={photo.title || ' '}
                                  actionIcon={
                                    <IconButton>
                                      <DeleteIcon
                                        onClick={this.removePhoto.bind(this, photoIndex, schedulingIndex)}
                                        color="white">刪除</DeleteIcon>
                                    </IconButton>
                                  }
                                >
                                  <img src={photo.url} />
                                </GridTile>
                              ))}
                            </GridList>
                          </div>
                        </div>
                      }
                      {
                        constants.canUploadVideo && (schedulingItem.mediaType === 'video' || schedulingItem.mediaType === 'none') &&
                        <div>
                          <Divider className="divider" />
                          <div className="video-block">
                            <FlatButton
                              label="插入影片"
                              primary={true}
                              icon={<AddIcon />}
                              onClick={this.openVideoDialog.bind(this, schedulingIndex)} />
                            {
                              _.map(schedulingItem.videos, (video, videoIndex) => (
                                <div className="video-row" key={videoIndex}>
                                  <lablel className="video-name">{video.title}</lablel>
                                  <IconButton
                                    className="delete-btn"
                                    tooltip="刪除"
                                    tooltipPosition="top-right"
                                    onClick={this.removeVideo.bind(this, videoIndex, schedulingIndex)}>
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              ))
                            }
                          </div>
                        </div>
                      }
                    </div>
                  )
                }
                <br />
                {/*<div>*/}
                {/*  <TextField*/}
                {/*    defaultValue={this.state.displaySelected.bottomText}*/}
                {/*    floatingLabelText="底部文字"*/}
                {/*    fullWidth={true}*/}
                {/*    onChange={wrapOnChange.bind(this, 'bottomText')}*/}
                {/*  />*/}
                {/*</div>*/}
              </div>
            }
            <PhotosDialog
              open={this.state.shouldOpenPhotosDialog}
              maxNoOfPhotosSelectable={constants.maxNoOfPhotosSelectable}
              maxNoOfPhotosUploadable={constants.maxNoOfPhotosUploadable}
              handleClose={this.closePhotoDialog}
              handleSubmit={this.submitPhotos.bind(this, this.state.schedulingIndex)} />
            <VideosDialog
              open={this.state.shouldOpenVideosDialog}
              maxNoOfVideosSelectable={constants.maxNoOfVideosSelectable}
              maxNoOfVideosUploadable={constants.maxNoOfVideosUploadable}
              handleClose={this.closeVideoDialog}
              handleSubmit={this.submitVideos.bind(this, this.state.schedulingIndex)} />
          </div>
        }
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }
}

export default Display;


// WEBPACK FOOTER //
// client/adminPanel/panel/displays/Display.js